import { FeatureFlagsDto } from "@/shared/types";

export type FeatureFlags = Record<string, boolean>

export const FeatureFlags = {
    fromDto(dto: FeatureFlagsDto): FeatureFlags {
        return dto.flags;
    }
};
